module.exports = __webpack_public_path__ + "images/ExternalPromo/mike-square-1.jpg?295de";